var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "settings-editor-base",
    [
      [
        _c(
          "button",
          { staticClass: "btn btn-primary", on: { click: _vm.showModal } },
          [_vm._v("\n            " + _vm._s(_vm.label) + "\n        ")]
        ),
        _vm._v(" "),
        _c("modal", {
          ref: "cropperModal",
          attrs: { size: _vm.modalSize },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function() {
                return [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        _vm.resource("SettingsMediaCropper_ModalHeader_Text")
                      )
                    )
                  ])
                ]
              },
              proxy: true
            },
            {
              key: "modal-body",
              fn: function() {
                return [
                  _c("media-library-image-crop", {
                    attrs: { "image-id": _vm.mediaId },
                    on: {
                      "image-cropped": function($event) {
                        return _vm.imageCropped($event.mediaId, $event.crop)
                      }
                    }
                  })
                ]
              },
              proxy: true
            }
          ])
        })
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }